import * as Yup from 'yup'

export const schema = Yup.object({
  userName: Yup.string().required('Usuário é obrigatório'),
  pwd: Yup.string().required('Senha é obrigatória'),
  rememberMe: Yup.boolean().notRequired(),
})
